if (!customElements.get('shop-the-look')) {
  customElements.define('shop-the-look', class ShopTheLook extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      // this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.cart = document.querySelector('cart-items');
      this.addedEvent = new CustomEvent('product:added')

      this.changeUrlOnVariantChange();
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      const { href } = submitButton.dataset;
      if (href) return window.location.href = href;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelectorAll(".loading-overlay__spinner").forEach((el) => el.classList.remove('hidden'));

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      if (!!this.cart) formData.append('sections', this.cart.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          document.dispatchEvent(this.addedEvent); // dispatch event product added
          if (!!this.cart) this.cart.renderContents(response);
        })
        .catch((e) => { })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelectorAll(".loading-overlay__spinner").forEach((el) => el.classList.add('hidden'));
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    changeUrlOnVariantChange() {
      const inputs = this.form.querySelectorAll('input[type="radio"]');
      const links = this.querySelectorAll('a[href^="/products/"]');
      const submitButtons = this.querySelectorAll('[type="submit"]');
      const submitButtonText = this.querySelectorAll('[type="submit"] span');

      inputs.forEach((input) => {
        input.addEventListener('change', (evt) => {
          const { variantInventoryQty, variantUrl, stringNotify, stringAddToCart } = evt.target.dataset;

          // Save selection
          sessionStorage.setItem(this.dataset.productId, evt.target.value);

          // Update all spans
          submitButtonText.forEach((span) => {
            span.textContent =
              variantInventoryQty <= 0 ? stringNotify : stringAddToCart;
          });

          // Update all submit buttons
          submitButtons.forEach((btn) => {
            btn.setAttribute(
              'data-href',
              variantInventoryQty <= 0 ? variantUrl : ''
            );
          });

          links.forEach((ahref) => (ahref.href = variantUrl));
        });
      });

      // Restore selection if coming back
      const savedVariantId = sessionStorage.getItem(this.dataset.productId);
      if (savedVariantId) {
        const savedInput = this.form.querySelector(`input[value="${savedVariantId}"]`);
        if (savedInput) {
          savedInput.checked = true;
          savedInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

  });

}